import React from 'react'
import { RemoveItem } from './RemoveItem'
import { ProductCardSmall } from '../../../components/ProductCardSmall'
import { QuantityInputWithUpdate } from './QuantityInputWithUpdate'
import { OrderPriceWrap } from '../../../components/OrderPriceWrap'
import { OutOfStockWarning } from '../OutOfStockWarning'
import type { Product } from '@ztechapps/common.contract'

type ContentRowProps = {
  product: Product
  _id: string
  quantity: number
  price: number
  net: number
  remarks: string
  refetch: any
  uom?: { _id?: string; code?: string; name?: string; symbol?: string }
}
export const ContentRow = ({ product, _id, quantity, price, net, remarks, uom }: ContentRowProps) => {
  return (
    <article className="card card-body mb-1">
      <div className="row align-items-center">
        <div className="col-md-6">
          <ProductCardSmall {...product} />
          <small className={'text-warning'}>{remarks}</small>
        </div>
        <div className="col">
          <QuantityInputWithUpdate quantity={quantity} itemId={_id} uomSymbol={uom?.symbol} />
        </div>
        <div className="col">
          <OrderPriceWrap {...{ net, price, uom: uom?.name }} />
        </div>
        <div className="col flex-grow-0 text-end">
          <RemoveItem {...{ itemId: _id }} />
        </div>
      </div>

      <OutOfStockWarning {...{ ...product, quantity }} />
    </article>
  )
}
